import React from 'react'
import './Works.css'
import fiverr from '../../img/fiverr.png'
import amazon from '../../img/amazon.png'
import upwork from '../../img/Upwork.png'
import Shopify from '../../img/Shopify.png'
import facebook from '../../img/Facebook.png'
import { themeContext } from '../../Context'
import { useContext } from 'react'
function Works() {
  const theme=useContext(themeContext);
  const darkMode=theme.state.darkMode
  return (
    <div className="works">
        {/* left */}
       <div className="awesome">
        <span style={{color:darkMode? 'white' : ''}}>Works For all These</span>
        <span>Brand & Clints</span>
        <span>Work in Software House
        <br /> 
        
        Lte Home 
        <br /> Front-end developer
        </span>
        
        
        <button className='button s-btn'>Hire Me</button>
        <div className="i-blur s-blur" style={{ background: "rgb(238 210 255)" }}> </div>
      </div>
      {/* right */}
      <div className="w-right">
        <div className="w-main-circle">
            <div className="w-sec-circle">
        <img src={upwork} alt="" />
        </div>
        <div className="w-sec-circle">
        <img src={fiverr} alt="" />
        </div>
        <div className="w-sec-circle">
        <img src={amazon} alt="" />
        </div>
        <div className="w-sec-circle">
        <img src={Shopify} alt="" />
        </div>
        <div className="w-sec-circle">
        <img src={facebook} alt="" />
        </div>
        </div>
        <div className="w-back-circle blue-circle"></div>
        <div className="w-back-circle yllow-circle"></div>
      </div>
    </div>
  
  )
}

export default Works